import { render, staticRenderFns } from "./TableAssigPermission.vue?vue&type=template&id=67fb8870"
import script from "./TableAssigPermission.vue?vue&type=script&lang=js"
export * from "./TableAssigPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports